import { gql } from '@apollo/client';

const RemoveDeviceMutation = gql`
    mutation DeleteMachine($input: DeleteMachine!) {
        deleteMachine(input: $input) {
            data
            message
            success
        }
    }
`;

export { RemoveDeviceMutation };
